import React, {Component} from 'react';
import {IMAGE_URL} from "../constants";
import ReactHtmlParser from "react-html-parser";
import './serviceSlider.css';

class ServiceSlider extends Component{
    state = {
        itemList: [],
        type: this.props.type,
        lang: this.props.lang,
        data: this.props.data,
        pageId: 0,
        itemPerPage: this.props.itemPerPage,
        leftArrow: false,
        rightArrow: true
    };
    componentWillMount() {
        this.pagination();
    }
    componentWillReceiveProps(props){
        this.setState({
            data: props.data,
            pageId: 0,
            leftArrow: false,
            rightArrow: (this.state.data.length !== this.state.itemPerPage)
        }, () => this.pagination());
    }
    pagination(){
        let itemList = [];
        for(let i=this.state.pageId; i<this.state.pageId+this.state.itemPerPage;i++){
            if(typeof this.props.data[i] != "undefined"){
                itemList.push(this.props.data[i]);
            }
        }
        this.setState({itemList});
    }
    previousPage(){
        if(this.state.pageId === 0){console.log("Return False");return false;}
        const newPageId =this.state.pageId-1;
        if(newPageId === 0){
            this.setState({pageId: newPageId, leftArrow: false, rightArrow: true}, ()=>this.pagination());
        }else
            this.setState({pageId: newPageId, rightArrow: true, leftArrow: true}, ()=>this.pagination());
    }
    nextPage(){
        if(this.state.pageId === this.props.data.length-this.state.itemPerPage){ console.log("Return False"); return false; }
        const newPageId = this.state.pageId+1;
        if(newPageId === this.props.data.length-this.state.itemPerPage){
            this.setState({pageId: newPageId, rightArrow: false, leftArrow: true}, ()=>this.pagination());
        }else
            this.setState({pageId: newPageId, rightArrow: true, leftArrow: true}, ()=>this.pagination());
    }
    render(){
        return (
            <div className="serviceSliderContainer">
                <div className="servicesContentArrow" onClick={()=>this.previousPage()}>
                    {this.state.leftArrow && <i className="fa fa-arrow-left"></i>}
                </div>
                {
                    this.state.itemList.length > 0 &&
                    this.state.itemList.map((item, index) => {
                        return <SliderItem key={index}
                                           type={this.state.type}
                                           lang={this.props.lang}
                                           detail={item}
                        />
                    })
                }
                <div className="servicesContentArrow" onClick={()=>this.nextPage()}>
                    {this.state.rightArrow && <i className="fa fa-arrow-right"></i>}
                </div>
            </div>
        );
    }
}

const SliderItem = (props) => {
    return (

        <div className="servicesDetail">
            <div className="servicesContent">
                {props.lang === "tr" && <div className="servicesItemTitle">{ReactHtmlParser(props.detail.title_tr)}</div>}
                {props.lang === "eng" && <div className="servicesItemTitle">{ReactHtmlParser(props.detail.title_eng)}</div>}

                {props.lang === "tr" && <div className="servicesItemText">{ReactHtmlParser(props.detail.content_tr)}</div>}
                {props.lang === "eng" && <div className="servicesItemText">{ReactHtmlParser(props.detail.content_eng)}</div>}
            </div>
            <div className="servicesImage">
                <img alt="" src={IMAGE_URL + props.detail.image2}/>
                <div className="servicesIndicator"></div>
            </div>
            <div className="servicesLogo">
                <img alt="" src={IMAGE_URL + props.detail.image1}/>
            </div>
        </div>

    );
};

export default ServiceSlider;